function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53 8.77s-3.488 2.691-5.314 2.134c-10.5-3.2-28.636-3.2-39.502 0-1.834.54-5.324-2.133-5.324-2.133s1.46 3.51 1.067 5.253c-1.945 8.615-2.437 16.359 0 24.709.5 1.712-1.067 5.242-1.067 5.242s3.161-2.679 4.837-2.133c10.834 3.527 30.557 3.2 39.827 0 1.851-.64 5.476 2.133 5.476 2.133s-1.32-3.205-1.067-4.999c1.255-8.87 1.255-16.337 0-24.79C51.648 12.265 53 8.77 53 8.77z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52.121 9.838c-4.386 12.566-3.2 21.336 0 33.07",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var SvgPillow = function SvgPillow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPillow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pillow.d8e695a2.svg";
export { ForwardRef as ReactComponent };